<template>
  <div class="typeFormBox">
    <PublicTitle :num="1" text="基本信息" />
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-spin :spinning="spinning">
        <a-form-model-item
          ref="enterpriseLogo"
          label="上传logo"
          prop="enterpriseLogo"
        >
          <div class="small-card">
            <a-upload
              name="file"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              :data="uploadData"
              :action="action"
              :before-upload="beforeUpload"
              @change="headImageChange"
              :disabled="formDisabled"
            >
              <img
                class="realImg"
                v-if="form.enterpriseLogo"
                :src="form.enterpriseLogo"
                alt="logo"
              />
              <div v-else>
                <div class="uploadImgBox headImageDefault">
                  <a-icon v-if="headImageLoading" type="loading" />
                </div>
              </div>
            </a-upload>
          </div>
        </a-form-model-item>
        <a-form-model-item
          ref="administratorsName"
          label="负责人姓名"
          prop="administratorsName"
        >
          <a-input
            :disabled="formDisabled"
            v-model="form.administratorsName"
            placeholder="请输入您的名字"
            maxLength=30
            @blur="
              () => {
                $refs.administratorsName.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item
          ref="administratorsPhone"
          label="联系方式"
          prop="administratorsPhone"
        >
          <a-input
            disabled
            v-model="form.administratorsPhone"
            placeholder="请输入联系方式"
            type="number"
            maxLength=15
            @blur="
              () => {
                $refs.administratorsPhone.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
        <!-- <a-form-model-item ref="like" label="您感兴趣的商品分类" prop="like">
                <a-tree-select
                :disabled="formDisabled"
                    v-model="form.like"
                    style="width: 100%"
                    :tree-data="treeData"
                    tree-checkable
                    :show-checked-strategy="SHOW_PARENT"
                    placeholder="请选择您感兴趣的商品分类"
                />
            </a-form-model-item> -->
      </a-spin>

      <PublicTitle :num="2" text="主体信息" :border="true" />
      <a-spin :spinning="spinning">
        <a-form-model-item
          ref="enterpriseTypeId"
          label="组织类型"
          prop="enterpriseTypeId"
        >
          <a-select
          placeholder="请选择组织类型"
            :disabled="formDisabled"
            v-model="form.enterpriseTypeId"
            
          >
            <a-select-option
              v-for="item in listData"
              :key="item.id"
              :value="item.id"
            >
              {{item.title}}
            </a-select-option>
          </a-select>
          <MiniIntroText>
            如果无特定类型请选择其它
          </MiniIntroText>
        </a-form-model-item>
        <a-form-model-item
          ref="enterpriseName"
          label="组织名称"
          prop="enterpriseName"
        >
          <a-input
            :disabled="formDisabled"
            v-model="form.enterpriseName"
            placeholder="请输入组织名称"
            maxLength=30
            @blur="
              () => {
                $refs.enterpriseName.onFieldBlur();
              }
            "
          />
          <MiniIntroText>
            需与当地政府颁发的商业许可证书或企业注册证上企业名称完全一致,信息审核成功企业名称不可修改
          </MiniIntroText>
        </a-form-model-item>
        <a-form-model-item
          ref="enterpriseCode"
          label="社会信用代码"
          prop="enterpriseCode"
        >
          <a-input
            :disabled="formDisabled"
            v-model="form.enterpriseCode"
            placeholder="请输入社会信用代码"
            maxLength=18
            @blur="
              () => {
                $refs.enterpriseCode.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item
          ref="enterpriseRegionCode"
          label="注册地址"
          prop="enterpriseRegionCode"
        >
          <!-- <a-cascader
            :disabled="formDisabled"
            :options="locationData"
            v-model="form.enterpriseRegionCode"
            placeholder="请选择注册地址"
            expand-trigger="hover"
            :show-search="{ filter }"
            @change="onChange"
          /> -->
          <el-cascader
            ref="cascader"
            style="width: 100%"
            size="small"
            :disabled="formDisabled"
            :props="props"
            expand-trigger="click"
            :show-search="{ filter }"
            @change="onChange"
            v-model="form.enterpriseRegionCode"
            :placeholder="form.enterpriseRegionCode?form.enterpriseRegion:'请选择注册地址'"
          ></el-cascader>
        </a-form-model-item>
        <a-form-model-item
          ref="enterpriseAdress"
          label="详细地址"
          prop="enterpriseAdress"
        >
          <a-textarea
            :disabled="formDisabled"
            v-model="form.enterpriseAdress"
            placeholder="请输入详细地址"
            maxLength=50
            @blur="
              () => {
                $refs.enterpriseAdress.onFieldBlur();
              }
            "
            :auto-size="{ minRows: 5, maxRows: 5 }"
          />
        </a-form-model-item>
        <a-form-model-item
          ref="enterpriseStartTime"
          label="营业期限"
          prop="enterpriseStartTime"
        >
         <el-checkbox v-model="form.enterpriseIsLongTerm" @change="clearDate" :disabled="formDisabled">长期</el-checkbox>
          <a-range-picker
          v-if="form.enterpriseIsLongTerm == false"
            :disabled="formDisabled"
            style="width: 100%"
            :value="
              form.enterpriseStartTime
                ? [
                    moment(form.enterpriseStartTime),
                    moment(form.enterpriseEndTime),
                  ]
                : []
            "
            separator="至"
            :format="dateFormat"
            valueFormat="YYYY-MM-DD"
            @change="dateChange"
            :placeholder="['开始日期', '结束日期']"
          />
          <div v-else>
             <a-date-picker
           
            :format="dateFormat"
            :disabled="formDisabled"
            valueFormat="YYYY-MM-DD"
            :placeholder="['开始日期']"
            @change="dateChange"
             :value="form.enterpriseStartTime"

    />
          </div>
          <MiniIntroText>
            请填写营业执照上营业期限,注意参照示例中的格式,结束时间需大于开始时间,有效期必须大于60天，如果为长期，请勾选长期
          </MiniIntroText>
        </a-form-model-item>
        <a-form-model-item
          ref="enterpriseLicense"
          label="营业执照"
          prop="enterpriseLicense"
        >
          <div class="big-card">
            <a-upload
              :disabled="formDisabled"
              name="file"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              :data="uploadData"
              :action="action"
              :before-upload="beforeUpload"
              @change="businessLicenseChange"
            >
              <img
                class="realImg"
                v-if="form.enterpriseLicense"
                :src="form.enterpriseLicense"
                alt="营业执照"
              />
              <div v-else>
                <div class="uploadImgBox businessLicenseImg">
                  <a-icon v-if="businessLicenseLoading" type="loading" />
                </div>
              </div>
            </a-upload>
          </div>
          <MiniIntroText style="width: 280px">
            仅支持在有效期内的中国大陆工商局或市场监督管理局颁发的工商营业执照。格式要求：原证照片、扫描件或者
            复印件加盖企业公章后的扫描
          </MiniIntroText>
        </a-form-model-item>
      </a-spin>

      <PublicTitle :num="3" text="法人信息" :border="true" />
      <a-spin :spinning="spinning">
        <a-form-model-item
          ref="enterpriseOperator"
          label="法人姓名"
          prop="enterpriseOperator"
        >
          <a-input
            :disabled="formDisabled"
            v-model="form.enterpriseOperator"
            placeholder="请输入法人姓名"
            maxLength=30
            @blur="
              () => {
                $refs.enterpriseOperator.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item
          ref="enterpriseIdCard"
          label="身份证号码"
          prop="enterpriseIdCard"
        >
          <a-input
            :disabled="formDisabled"
            v-model="form.enterpriseIdCard"
            placeholder="请输入身份证号码"
            maxLength=18
            @blur="
              () => {
                $refs.enterpriseIdCard.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item
          ref="enterpriseCardStartTime"
          label="身份证有效期"
          prop="enterpriseCardStartTime"
        >
        <el-checkbox v-model="form.enterpriseCardIsLongTerm" @change="clearDate2" :disabled="formDisabled">长期</el-checkbox>
          <a-range-picker
           v-if="form.enterpriseCardIsLongTerm== false"
            :disabled="formDisabled"
            style="width: 100%"
            :value="
              form.enterpriseCardStartTime
                ? [
                    moment(form.enterpriseCardStartTime),
                    moment(form.enterpriseCardEndTime),
                  ]
                : []
            "
            separator="至"
            :format="dateFormat"
            valueFormat="YYYY-MM-DD"
            @change="dateChange_card"
            :placeholder="['开始日期', '结束日期']"
          />
           <div v-else>
             <a-date-picker          
            :format="dateFormat"
            :disabled="formDisabled"
            valueFormat="YYYY-MM-DD"
            :placeholder="['开始日期']"
            @change="dateChange_card"
             :value="form.enterpriseCardStartTime"   
            />
          </div>
          <MiniIntroText> 结束时间要大于开始时间5年以上，如果为长期，请勾选长期 </MiniIntroText>
        </a-form-model-item>
        <a-form-model-item
          ref="enterpriseCardPositive"
          label="证件照片"
          prop="enterpriseCardPositive"
          class="enterpriseCardPositive"
        >
          <div class="big-card">
            <a-upload
              :disabled="formDisabled"
              name="file"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              :data="uploadData2"
              :action="action"
              :before-upload="beforeUpload"
              @change="idCardImgFrontChange"
            >
              <img
                class="realImg"
                v-if="form.enterpriseCardPositive"
                :src="form.enterpriseCardPositive"
                alt="证件照正面2"
              />
              <div v-else>
                <div class="uploadImgBox idCardImgFront">
                  <a-icon v-if="idCardImgFrontLoading" type="loading" />
                </div>
              </div>
            </a-upload>
            <a-upload
              :disabled="formDisabled"
              name="file"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              :data="uploadData2"
              :action="action"
              :before-upload="beforeUpload"
              @change="idCardImgBcakChange"
            >
              <img
                class="realImg"
                v-if="form.enterpriseCardSide"
                :src="form.enterpriseCardSide"
                alt="证件照背面"
              />
              <div v-else>
                <div class="uploadImgBox idCardImgBack">
                  <a-icon v-if="idCardImgBackLoading" type="loading" />
                </div>
              </div>
            </a-upload>
          </div>
        </a-form-model-item>
        <PublicTitle :num="4" text="推广商" :border="true" />
        <a-form-model-item
          ref="promoter"
          label="推广商"
          prop="promoter"
        >
          <a-select
            placeholder="请选择推广商"
            :default-value="form.promoter"
            :disabled="formDisabled"
            v-model="form.promoter"
          >
            <a-select-option
              v-for="(item,index) in promoterData"
              :key="index"
              :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
          <!-- <MiniIntroText> 如果无特定类型请选择其它 </MiniIntroText> -->
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 24 }">
          <div class="btn-box">
            <a-button @click="resetForm" :disabled="formDisabled">
              取消
            </a-button>
            <a-button
              style="margin-left: 37px"
              type="primary"
              @click="onSubmit"
              :disabled="formDisabled"
            >
              提交
            </a-button>
          </div>
        </a-form-model-item>
      </a-spin>
    </a-form-model>
  </div>
</template>
<script>
import PublicTitle from "../components/publicTitle.vue";
import MiniIntroText from "../components/miniIntroText.vue";
import { TreeSelect } from "ant-design-vue";
import moment from "moment";
import locationData from "@/util/locationData.js";
import api from "@/api";
import { listSearchMixin } from "@/config/mixin";
const SHOW_PARENT = TreeSelect.SHOW_PARENT;
export default {
  mixins: [listSearchMixin],
  components: {
    PublicTitle,
    MiniIntroText,
  },
  props:["type"],
  data() {
    return {
      isDisable:false,
      spinning: false,
      formDisabled: false,
      flag:false,
      enterpriseId:"",
      action: api.upload,
      uploadData:{
        filePath:8
      },
      uploadData2:{
        filePath:7
      },
      SHOW_PARENT,
      locationData,
      dateFormat: "YYYY年MM月DD日",
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      businessLicenseLoading: false,
      idCardImgFrontLoading: false,
      idCardImgBackLoading: false,
      headImageLoading: false,
      headImageUrl: null,
      treeData: [
        {
          title: "大宗粮油",
          value: "0-0",
          key: "0-0",
          children: [
            {
              title: "大米",
              value: "0-0-0",
              key: "0-0-0",
            },
            {
              title: "食用油",
              value: "0-0-1",
              key: "0-0-1",
            },
            {
              title: "面粉",
              value: "0-0-2",
              key: "0-0-2",
            },
            {
              title: "农副产品",
              value: "0-0-3",
              key: "0-0-3",
            },
            {
              title: "五谷杂粮",
              value: "0-0-4",
              key: "0-0-4",
            },
            {
              title: "有机食品",
              value: "0-0-5",
              key: "0-0-5",
            },
          ],
        },
        {
          title: "校际商圈",
          value: "1-0",
          key: "1-0",
          children: [
            {
              title: "办公用品",
              value: "1-0-0",
              key: "1-0-0",
            },
            {
              title: "学习文具",
              value: "1-0-1",
              key: "1-0-1",
            },
            {
              title: "零食百货",
              value: "1-0-2",
              key: "1-0-2",
            },
          ],
        },
      ],
      other: "",
      enterpriseRegion_option: [],
      form: {
        administratorsName: "",
        administratorsPhone: "",
        // like:[],
        enterpriseLogo: "",
        authenType: 4, //授权类型 2个体 3企业 4其他组织
        enterpriseTypeId: "12781d76191e41ef82fee00ee3ff91d9",
        enterpriseName: "", // 企业名称
        enterpriseCode: "", // 统一社会信用代码
        enterpriseRegion: "", // 注册地址 省-市-区
        enterpriseRegionCode: "", // 注册地址 省-市-区 code
        enterpriseAdress: "", // 注册地址详细
        enterpriseStartTime: "", // 营业期限开始时间
        enterpriseEndTime: "", // 营业期限结束时间
        enterpriseLicense: "", // 营业执照图片地址
        enterpriseOperator: "", // 经营者姓名
        contactMobile: "", // 联系人电话号码
        enterpriseCardType: "1", // 身份证类型
        enterpriseIdCard: "", // 经营者身份证号码
        enterpriseCardStartTime: "", // 证件有效开始时间
        enterpriseCardEndTime: "", // 证件有效结束时间
        enterpriseCardPositive: "", // 身份证正面照
        enterpriseCardSide: "", // 身份证反面照
        enterpriseCardIsLongTerm:false,//证件是否长期
        enterpriseIsLongTerm:false, //营业期限是否长期
        promoter:""//推广商
      },
      listData: [],
      promoterData:[
        "无","云南亚泰会展有限公司","云南亮剑国际展览有限公司","云南道和文化传播有限公司","保山零浩文化传媒有限公司","昆明妙峰文化传播有限公司","云南千业投资有限公司","昆明浩宇文化传播有限公司","昆明楚江商贸有限公司","云南创影文旅发展有限公司","云南中鲜健康服务有限公司","楚雄瑞晨会展有限公司","福州市头脑风暴文化创意有限公司云南分公司","海悦商贸(大理)有限公司","云南典燃文化传媒有限公司","云南铭企文化传媒有限公司","大理天韵文化传播有限公司","云南飞限弘映文化传媒有限公司","云南七彩文旅发展有限公司","云南路畅文化传播有限公司","云南琳康商贸有限公司","云南派莱贸易有限公司"
      ],
      rules: {
        administratorsName: [
          { required: true, message: "负责人姓名不能为空", trigger: "blur" },
          // { min: 1, max: 5, message: '名字过长', trigger: 'blur' },
        ],
        administratorsPhone: [
          { validator: this.validatePhone, required: true, trigger: "blur" },
        ],
        enterpriseTypeId: [
          { required: true, validator: this.validateTypeId, trigger: "blur" },
        ],
        enterpriseName: [
          { required: true, message: "组织名称不能为空", trigger: "blur" },
        ],
        enterpriseCode: [
          { required: true, validator: this.validateCode, trigger: "blur" },
        ],
        enterpriseRegionCode: [
          { required: true, message: "注册地址不能为空", trigger: "blur" },
        ],
        enterpriseStartTime: [
          { validator: this.validatelicense, required: true, trigger: "blur" },
        ],
        enterpriseCardStartTime: [
          { validator: this.validateCardTime, required: true, trigger: "blur" },
        ],
        enterpriseLicense: [
          { required: true, message: "营业执照不能为空", trigger: "blur" },
        ],
        enterpriseOperator: [
          { required: true, message: "经营者姓名不能为空", trigger: "blur" },
        ],
        enterpriseIdCard: [
          { validator: this.validateIdCard, required: true, trigger: "blur" },
        ],
        enterpriseCardPositive: [
          { required: true, message: "证件照片不能为空", trigger: "blur" },
        ],
        promoter: [
          { required: true, message: "推广商不能为空", trigger: "blur" },
        ],
      },
      props: {
        lazy: true,

        lazyLoad: this.getProvinceList,
      },
    };
  },
  mounted() {
    console.log(this.type)
    // this.authenType = this.type
    this.checkPass();
    this.getEnterpriseCheckData();
    this.enterpriseList();
    // this.checkPass()
  },
  methods: {
    //获取省级列表
    getProvinceList(node, resolve) {
      
      if (!node) {
        return false;
      }
      const { level } = node;
      
      if (level === 0) {
        let params = {
          url: api.getProvinceList,
          method: "POST",
        };
        this.sendReq(params, (res) => {
          
          console.log(res);
          if (res.code == "200") {
            // this.ProvinceList = res.data;
            const nodes = Array.from(res.data).map((item) => ({
              value: item.value,
              label: item.label,
              // leaf: (level = 1),
            }));
            
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }
        });
      }
      if (level === 1) {
        
        let params2 = {
              url: api.getChildren,
              method: "POST",
              data: {
                regionId: node.value,
              },
            };
            this.sendReq(params2, (res) => {
              debugger
              console.log(res);
              if (res.code == "200") {
                // this.ProvinceList = res.data;
                const nodes = Array.from(res.data).map((item) => ({
                  value: item.value,
                  label: item.label,
                  children:item.children,
                  // leaf: (level >=2),
                }));

                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                resolve(nodes);
              }
            });
      }
      if (level === 2) {
        
        let params2 = {
              url: api.getChildren,
              method: "POST",
              data: {
                regionId: node.value,
              },
            };
            this.sendReq(params2, (res) => {
              debugger
              console.log(res);
              if (res.code == "200") {
                // this.ProvinceList = res.data;
                const nodes = Array.from(res.data).map((item) => ({
                  value: item.value,
                  label: item.label,
                  // children:item.children,
                  // leaf: (level >=2),
                }));

                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                resolve(nodes);
              }
            });
      }
      if (level === 3) {
        
        let params2 = {
              url: api.getChildren,
              method: "POST",
              data: {
                regionId: node.value,
              },
            };
            this.sendReq(params2, (res) => {
              debugger
              console.log(res);
              if (res.code == "200") {
                // this.ProvinceList = res.data;
                const nodes = Array.from(res.data).map((item) => ({
                  value: item.value,
                  label: item.label,
                  // children:item.children,
                  leaf: (level >=3),
                }));

                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                resolve(nodes);
              }
            });
      }
      
    },
    clearDate(){
      this.form.enterpriseStartTime = ''
     this.form.enterpriseEndTime  = ''
    },
    clearDate2(){
      this.form.enterpriseCardStartTime = ''
      this.form.enterpriseCardEndTime = ''
    },
    validatePhone(rule, value, callback) {
      let reg = /^(0|86|17951)?(1[3-9])[0-9]{9}$/;
      let res = reg.test(value);
      if (!value) {
        return callback(new Error("联系方式不能为空"));
      } else if (!res) {
        return callback(new Error("请输入正确的联系方式"));
      } else {
        callback();
      }
    },
    validateCode(rule, value, callback) {
      if (!value) {
        return callback(new Error("社会信用代码不能为空"));
      } else if (value.length<18) {
        return callback(new Error("社会信用代码不足18位"));
      } else {
        callback();
      }
    },
    validateTypeId(rule, value, callback) {
      if (value === undefined) {
        return callback(new Error("组织类型不能为空"));
      } else {
        callback();
      }
    },
    validatelicense(rule, value, callback) {
      if (this.form.enterpriseIsLongTerm == false) {
        let start = moment(this.form.enterpriseStartTime);
        let end = moment(this.form.enterpriseEndTime);
        let distance = end.diff(start, "day");

        if (!value) {
          callback(new Error("营业期限不能为空"));
        } else if (distance < 60) {
          callback(new Error("结束时间要大于开始时间60天以上"));
        } else {
          callback();
        }
      } else {
        if (!value) {
          callback(new Error("营业期限不能为空"));
        } else {
          callback();
        }
      }
    },
    validateCardTime(rule, value, callback) {
      if (this.form.enterpriseCardIsLongTerm == false) {
        let start = this.form.enterpriseCardStartTime.slice(0, 4);
        let end = this.form.enterpriseCardEndTime.slice(0, 4);
        let distance = end - start;

        if (!value) {
          callback(new Error("证件有效期限不能为空"));
        } else if (distance < 5) {
          callback(new Error("结束时间要大于开始时间5年以上"));
        } else {
          callback();
        }
      } else {
        if (!value) {
          callback(new Error("证件有效期限不能为空"));
        } else {
          callback();
        }
      }
    },
    validateIdCard(rule, value, callback) {
      let reg = /^\d{17}(\d|X|x)$/;
      if (!value) {
        callback(new Error("身份证号码不能为空"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的身份证号码"));
      } else {
        callback();
      }
    },
    moment,
    checkPass() {
      //获取当前的认证状态
      let params = {
        url: api.enterprisePass,
        method: "POST",
        data: {},
      };
      this.sendReq(params, (res) => {
        if(res.data.administratorsPhone){
          this.form.administratorsPhone = res.data.administratorsPhone
          this.isDisable = true
        }else{
          this.isDisable = false
        }

        if (res.code === "200") {
          this.$message({
            message: "您当前认证已经通过,无需再操作",
            type: "success",
          });
          this.formDisabled = true;
        } else {
          switch (res.code) {
            case "40014": //审核中
            case "40016": //被禁用
              this.$message({
                message: `${res.message}`,
                type: "warning",
              });
              this.formDisabled = true;
              break;
            case "40015": //被拒绝
              this.flag = true;
              this.$message({
                message: `${res.message}`,
                type: "error",
              });
              this.formDisabled = false;
              break;
            default:
              //未提交
              this.formDisabled = false;
              break;
          }
        }
      });
    },
    enterpriseList() {
      let params = {
        url: api.getEnterpriseList,
        method: "POST",
        data: {
          authenType: this.form.authenType,
        },
      };
      this.sendReq(params, (res) => {
        console.log(res);
        if (res.code == "200") {
          this.listData = res.data;
        }
      });
    },
    getEnterpriseCheckData() {
      //获取提交过的认证信息
      let params = {
        url: api.enterpriseGetData,
        method: "POST",
        data: {},
      };
      this.sendReq(params, (res) => {
        if(res.data && res.data.administratorsPhone){
          this.form.administratorsPhone = res.data.administratorsPhone
          this.isDisable = true
        }else{
          this.isDisable = false
        }
        if (res.data && res.data.enterpriseCode) {
          this.enterpriseId = res.data.id
          if(!res.data.enterpriseTypeId || res.data.enterpriseTypeId  == ''){
            res.data.enterpriseTypeId = ""
          }
          this.authenType =  res.data.authenType
          this.fillBackForm(res.data);
        }
      });
    },
    fillBackForm(data) {
      let _data = data;
      if (data.authenType == this.form.authenType) {
        this.form.administratorsPhone = data.administratorsPhone;
        if (_data.enterpriseRegionCode) {
          this.form = {
            ...this.form,
            ..._data,
            enterpriseRegionCode: _data.enterpriseRegionCode.split("-"),
          };
        }else{
          this.form = {
            ...this.form,
            ..._data,
            enterpriseRegionCode: _data.enterpriseRegionCode,
          };
        }

        if (this.form.enterpriseEndTime == null) {
          this.form.enterpriseEndTime = "";
        }

        if (this.form.enterpriseCardEndTime == null) {
          this.form.enterpriseCardEndTime = "";
        }
      }
    },
    formatSubmit(data) {
      let obj = JSON.parse(JSON.stringify(data));
      obj = {
        ...obj,
        enterpriseRegionCode: obj.enterpriseRegionCode.join("-"),
      };
      return obj;
    },
    onSubmit() {
      debugger
      console.log(this.form);
      if(this.flag){
        this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let form = this.formatSubmit(this.form);
          this.form.authenType = this.type
          let self = this;
          let params = {
            url: api.editEnterprise,
            method: "POST",
            data: {
              id:self.enterpriseId,
              ...form,
            },
          };
          this.spinning = true;
          self.sendReq(params, (res) => {
            this.spinning = false;
            if (res.code === "200") {
              self.$message({
                message: "提交成功,正在审核!",
                type: "success",
              });
              self.formDisabled = true;
            } else {
              self.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        } else {
          this.$message({
            message: "您的信息填写有误,请检查后再次提交",
            type: "error",
          });
          return false;
        }
      });
      }else{
        this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let form = this.formatSubmit(this.form);
          this.form.authenType = this.type
          let self = this;
          let params = {
            url: api.enterpriseCheck,
            method: "POST",
            data: {
              ...form,
            },
          };
          this.spinning = true;
          self.sendReq(params, (res) => {
            this.spinning = false;
            if (res.code === "200") {
              self.$message({
                message: "提交成功,正在审核!",
                type: "success",
              });
              self.formDisabled = true;
            } else {
              self.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        } else {
          this.$message({
            message: "您的信息填写有误,请检查后再次提交",
            type: "error",
          });
          return false;
        }
      });
      }
      
    },
    idCardImgFrontChange(info) {
      if (info.file.status === "uploading") {
        this.idCardImgFrontLoading = true;
        return;
      }
      if (info.file.status === "done") {
        try {
          this.form.enterpriseCardPositive = info.file.response.data.url;
        } catch (err) {}
        this.idCardImgFrontLoading = false;
      }
    },
    idCardImgBcakChange(info) {
      if (info.file.status === "uploading") {
        this.idCardImgBackLoading = true;
        return;
      }
      if (info.file.status === "done") {
        try {
          this.form.enterpriseCardSide = info.file.response.data.url;
        } catch (err) {}
        this.idCardImgBackLoading = false;
      }
    },
    businessLicenseChange(info) {
      if (info.file.status === "uploading") {
        this.businessLicenseLoading = true;
        return;
      }
      if (info.file.status === "done") {
        try {
          this.form.enterpriseLicense = info.file.response.data.url;
        } catch (err) {}
        this.businessLicenseLoading = false;
      }
    },
    headImageChange(info) {
      if (info.file.status === "uploading") {
        this.headImageLoading = true;
        return;
      }
      if (info.file.status === "done") {
        try {
          this.form.enterpriseLogo = info.file.response.data.url;
        } catch (err) {}
        this.headImageLoading = false;
      }
    },
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "application/pdf";
      if (!isJpgOrPng) {
        this.$message.error("文件需为jpg/png/pdf格式");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("文件不可以超过2M");
      }
      return isJpgOrPng && isLt2M;
    },
    onChange(value) {
      debugger;
      let node = this.$refs['cascader'].getCheckedNodes()[0].pathLabels;
      // console.log(node);
      // console.log(this.form.enterpriseRegionCode)
      // this.form.enterpriseRegionCode = value
      // this.form.enterpriseRegionCode = value.map((item) => item).join("-");
      this.form.enterpriseRegion = node.map((item) => item).join("-");
      console.log(this.form.enterpriseRegion);
    },
    dateChange(date, str) {
      if(this.form.enterpriseIsLongTerm == true){
         this.form.enterpriseStartTime = date
         this.form.enterpriseEndTime = ""
      }else{
        this.form.enterpriseStartTime = date[0];
      this.form.enterpriseEndTime = date[1];
      }
      
      
    },
    dateChange_card(date, str) {
      if(this.form.enterpriseCardIsLongTerm == true){
         this.form.enterpriseCardStartTime = date
         this.form.enterpriseCardEndTime = ""
      }else{
      this.form.enterpriseCardStartTime = date[0];
      this.form.enterpriseCardEndTime = date[1];
      }
    },
    filter(inputValue, path) {
      return path.some(
        (option) =>
          option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
      );
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>
<style lang="less">
.typeFormBox {
  .big-card {
    display: flex;
    justify-content: space-between;
    .ant-upload-picture-card-wrapper {
      width: 290px !important;
    }
    .ant-upload-select-picture-card {
      display: inline-block !important;
      width: 290px !important;
      height: 180px !important;
      position: relative !important;
      overflow: hidden !important;
      margin-right: 0 !important;
    }
  }
  .small-card {
    display: flex;
    justify-content: space-between;
    .ant-upload-picture-card-wrapper {
      width: 98px !important;
    }
    .ant-upload-select-picture-card {
      display: inline-block !important;
      width: 98px !important;
      height: 98px !important;
      position: relative !important;
      overflow: hidden !important;
      margin-right: 0 !important;
    }
  }
  .ant-btn {
    height: 55px !important;
    padding: 0 50px !important;
    font-size: 18px !important;
  }
}
</style>
<style lang="less" scoped>
.uploadImgBox {
  position: absolute;
  width: 100%;
  height: 100%;
  display: inline-block;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  i {
    font-size: 40px;
    color: #ff770098;
  }
}
.businessLicenseImg {
  background: url(../../../../assets/images/businessLicense.png) no-repeat
    center;
  background-size: cover;
}
.idCardImgFront {
  background: url(../../../../assets/images/idCardFront.png) no-repeat center;
  background-size: cover;
}
.idCardImgBack {
  background: url(../../../../assets/images/idCardBack.png) no-repeat center;
  background-size: cover;
}
.headImageDefault {
  background: url(../../../../assets/images/defaultHeadImg.png) no-repeat center;
  background-size: cover;
}
.realImg {
  width: 100%;
}
.btn-box {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/userCenter/companyCertificate/pages/publicInstitutionPerson.vue